<template>
  <div id="dashboard">
    <!-- <Breadcrumb :list="list"/> -->
    <div class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="card datepickerwrap" style="flex-direction: row">
      <div class="wrapitem" style="width: 100%; display: flex; flex-direction: row">
        <div style="width: 100%; display: flex; flex-direction: row">
          <div style="width: 60%">
            <datecomponent ref="datecomponent"> </datecomponent>
          </div>
          <div class="datebox" style="width: 11%; position: relative; right: 190px">
            <button @click="refresh" class="btn primarycolor" type="button">
              <span>Submit</span>
            </button>
          </div>
          <div class="datebox" style="position: relative; left: 40px">
            <button class="btn primarycolor" @click="createPdf">Download</button>
          </div>
          <div class="datebox customSelect">
            <p class="channel-title">Channel:</p>
            <select
              @change="processCategory"
              v-model="channelSelector"
              class="form-control text-uppercase"
            >
              <!-- <option value="">All </option> -->
              <option value="amazon">Amazon</option>
              <!-- <option value="flipkart">Flipkart</option> -->
              <!-- <option value="walmart">Walmart </option>
            <option value="BESTBUY">Best Buy </option>
            <option value="jd">JD</option>
            <option value="costco">Costco </option>
            <option value="hp">HP </option> -->
            </select>
          </div>
          <div class="datebox customSelect">
            <select
              @change="icChanged"
              v-model="selectedItemCategory"
              class="form-control text-uppercase"
            >
              <option v-for="d in itemCategory" :value="d" :key="d.key">
                {{ d.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div id="dashboardPdf">
      <!-- <h3 class="cust-head">Total Reviews</h3> 
      -->

      <div>
        <div
          class="d-flex datepickerwrap"
          style="margin-right: 0 !important; padding-bottom: 0px"
        >
          <div class="separated-card w-100" v-for="(ud, i) in products" :key="i">
            <div data-html2canvas-ignore="true" class="customSelect">
              <select
                @change="changeProduct(ud, i)"
                v-model="selectedProducts[i]"
                class="form-control customSelect text-uppercase"
                style="margin-bottom: -10px"
              >
                <optgroup label="Primary">
                  <option v-for="d in primaryProductsOptions" :value="d.product_name">
                    {{ d.product_name.toUpperCase() }}
                  </option>
                </optgroup>
                <optgroup label="Competitor">
                  <option v-for="d in nonPrimaryProductsOptions" :value="d.product_name">
                    {{ d.product_name.toUpperCase() }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
        </div>

        <div class="datepickerwrap" style="margin-right: 0 !important">
          <h5 class="positive-head" style="margin-top: 2px !important">
            Reviews and Rating
          </h5>
          <div
            class="datepickerwrap d-flex ml-0 mr-0 pr-0 mb-0 pb-0"
            style="margin-top: -5px !important; margin-right: 0 !important"
          >
            <div
              class="card separated-card w-100 mb-0"
              :key="idx"
              v-for="(ud, idx) in products"
            >
              <div>
                <div style="margin: 10px; height: 100%">
                  <div class="space-between-header" style="border: none !important"></div>
                  <div
                    class="pb-0 d-flex justify-content-around align-items-center mb-3 mt-2"
                  >
                    <div
                      class="d-flex flex-column align-items-center"
                      style="
                        border-right: 0.13rem solid #e1e1e1 !important;
                        padding-right: 16%;
                      "
                    >
                      <h4
                        class="mb-0"
                        style="color: var(--green); font-size: 2rem; font-weight: 600"
                      >
                        <span>{{ reviewCountMapper[ud.product_name] | format }}</span>
                      </h4>
                      <p
                        class="text-capitalize"
                        style="color: var(--primary_brand); font-size: 1rem"
                      >
                        Total Reviews
                      </p>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                      <h4
                        class="mb-0"
                        style="color: var(--green); font-size: 2rem; font-weight: 600"
                      >
                        <span
                          v-if="
                            recentRating[ud.product_name] &&
                            recentRating[ud.product_name].recent_rating
                          "
                          style="float: right"
                        >
                          --> {{ recentRating[ud.product_name].recent_rating }}&nbsp;
                          <!-- <i
                      style="font-size: 12px; line-height: 16px"
                      class="fa fa-star float-right"
                    ></i> -->
                        </span>
                        <span class="float-right">{{
                          ratingMapper[ud.product_name].review_avg | format
                        }}</span>
                      </h4>
                      <p
                        class="text-capitalize"
                        style="color: var(--primary_brand); font-size: 1rem"
                      >
                        Total Ratings
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="ratingMapper[ud.product_name]">
                <h5 class="text-capitalize mb-2">
                  <span
                    style="
                      max-width: 82%;
                      display: inline-block;
                      color: var(--primary_brand);
                    "
                  >
                  </span>
                </h5>
                <div
                  class="progress-group"
                  v-for="r in ratingMapper[ud.product_name].ratings"
                >
                  <div class="progress-group-header">
                    <i class="fa fa-star text-star-color" v-for="s in r.rating"></i>
                    <span class="ml-auto">
                      {{ r.count | format }}
                      <span class="text-muted small">({{ r.per | format }}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <div class="progress progress-xs">
                      <div
                        role="progressbar"
                        class="progress-bar"
                        style="background-color: var(--green-80); border-radius: 1rem"
                        :class="'card_' + ud.brand_name"
                        :style="'width:' + r.per + '%'"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <h3 class="cust-head">Ratings</h3> -->
        <div class="card datepickerwrap">
          <b-row>
            <b-col sm="5">
              <h5 id="traffic" class="card-title mb-0">Number of reviews</h5>
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              <b-button-toolbar
                class="float-right"
                aria-label="Toolbar with buttons group"
              >
                <b-form-radio-group
                  class="mr-3 radiohide"
                  id="radiosBtn"
                  buttons
                  button-variant="outline-secondary"
                  v-model="selected"
                  name="radiosBtn"
                >
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <highcharts :options="charts.review_count" v-if="activeChart"></highcharts>
          <div v-if="!activeChart">No Data</div>
        </div>
        <div class="card datepickerwrap">
          <b-row>
            <b-col sm="5">
              <h5 id="traffic" class="card-title mb-0">Average review rank</h5>
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              <b-button-toolbar
                class="float-right"
                aria-label="Toolbar with buttons group"
              >
                <b-form-radio-group
                  class="mr-3 radiohide"
                  id="radiosBtn"
                  buttons
                  button-variant="outline-secondary"
                  v-model="selected"
                  name="radiosBtn"
                >
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <!--highchart-->
          <highcharts :options="charts.rating" v-if="activeChart"></highcharts>
          <div v-if="!activeChart">No Data</div>
        </div>
        <div class="card datepickerwrap">
          <h3 class="card-title">Voice of Customers</h3>
          <b-row>
            <b-col sm="5" style="border-right: 1px solid #e1e1e1">
              <highcharts v-if="data.length" :options="charts.circlular" />
              <div v-if="!data.length">No data</div>
            </b-col>
            <b-col sm="7">
              <highcharts v-if="data.length" :options="charts.stackgraph" />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardLine1ChartExample from ".././dashboard/CardLine1ChartExample";
import CardLine2ChartExample from ".././dashboard/CardLine2ChartExample";
import CardLine3ChartExample from ".././dashboard/CardLine3ChartExample";
import CardBarChartExample from ".././dashboard/CardBarChartExample";
import SocialBoxChartExample from ".././dashboard/SocialBoxChartExample";
import CalloutChartExample from ".././dashboard/CalloutChartExample";
import { Callout } from "@coreui/vue";
import moment from "moment";
import datecomponent from "./DateMotherCare.vue";

export default {
  name: "dashboard",
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    datecomponent,
  },

  data: function () {
    return {
      promises: [],
      selected: "month",
      data: [],
      userData: JSON.parse(localStorage.getItem("reviewUserData")),
      customData: JSON.parse(localStorage.getItem("reviewCustomData")),
      products: [],
      nonPrimaryProductsOptions: [],
      primaryProductsOptions: [],
      selectedProducts: [],
      reviewCountMapper: {},
      ratingMapper: {},
      dateDropDown: "custom",
      credits: false,
      loader: true,
      channelSelector: "",
      activeChart: false,
      charts: {
        circlular: {},
        stackgraph: {},
      },
      date: {},
      itemCategory: [],
      selectedItemCategory: {},
      productList: {},
      competitorData: {},
      recentRating: {},
      client: "rangita",
    };
  },
  watch: {
    selected: function () {
      this.getChartData();
    },
  },
  mounted() {
    if (localStorage.demo_voc_channelSelector)
      this.channelSelector = localStorage.demo_voc_channelSelector;
    else this.channelSelector = "amazon";
    this.processCategory();
    this.getCompetitorSet();
  },
  methods: {
    getCompetitorSet() {
      let self = this;
      let url = "/api/india_clinets/product_set_list_compare";
      let payload = {
        client: self.client,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.competitorData = response.body.data.voc_product_list;
        },
        (err) => {
        }
      );
    },
    processCategory() {
      localStorage.demo_voc_channelSelector = this.channelSelector;
      this.itemCategory = [];
      if (localStorage.demo_voc_product_list)
        this.productList = JSON.parse(localStorage.demo_voc_product_list);
      for (let [i, k] of Object.keys(this.productList[this.channelSelector]).entries()) {
        this.itemCategory.push({ key: k, value: k.replace("_", " ") });
      }
      if (localStorage.demo_selectedItemCategory) {
        this.selectedItemCategory = {};
        for (let [i, k] of this.itemCategory.entries()) {
          if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
            this.selectedItemCategory = k;
          }
        }
        if (!Object.keys(this.selectedItemCategory).length) {
          this.selectedItemCategory = this.itemCategory[0];
        }
      } else {
        this.selectedItemCategory = this.itemCategory[0];
      }
      this.init();
    },
    icChanged() {
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
      this.init();
    },
    init() {
      this.nonPrimaryProductsOptions = [];
      this.primaryProductsOptions = [];
      this.products = [];
      this.selectedProducts = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let ci = 0;
      for (let [i, k] of this.productList[this.channelSelector][
        this.selectedItemCategory.key
      ].entries()) {
        let obj = {
          brand: "test",
          color: color[ci],
          forum: false,
          primary: k.primary,
          product_name: k.name,
        };
        if (k.primary) this.primaryProductsOptions.push(obj);
        else this.nonPrimaryProductsOptions.push(obj);
        if (ci == color.length - 1) ci = 0;
        else ci++;
      }
      this.products = [
        this.primaryProductsOptions[0],
        this.nonPrimaryProductsOptions[0],
        this.nonPrimaryProductsOptions[1],
      ];
      this.selectedProducts = [
        this.primaryProductsOptions[0].product_name,
        this.nonPrimaryProductsOptions[0].product_name,
        this.nonPrimaryProductsOptions[1].product_name,
      ];
      this.refresh();
    },
    createPdf() {
      let self = this;
      self.loader = true;
      let content = document.querySelector("#dashboardPdf");
      let canvasWidth = content.scrollWidth + 5;
      let canvasHeight = content.scrollHeight + 5;
      let options = {
        scale: 1.5,
        width: canvasWidth,
        onclone: function () {
          alert("Pdf generated. Download Now");
        },
      };
      setTimeout(function () {
        html2canvas(content, options).then((canvas) => {
          let imgData = canvas.toDataURL("image/jpeg", 1.0);
          let doc = new jsPDF("p", "mm", [canvasWidth, canvasHeight]);
          let pdfWidth = canvasWidth - 16;
          let pdfHeight = canvasHeight;
          doc.addImage(imgData, "JPEG", 8, 8, pdfWidth, pdfHeight);
          doc.save("voc_weavr_dashboard_" + moment().format("DDMMMYYYY") + ".pdf");
          self.loader = false;
        });
      }, 0);
    },

    changeProduct(ud, idx) {
      let self = this;
      if (idx == 0) {
        let isPrimary = false;
        let compData =
          self.competitorData[this.channelSelector][this.selectedItemCategory.key][
            self.selectedProducts[0]
          ];
        for (let [ci, cdata] of this.productList[this.channelSelector][
          this.selectedItemCategory.key
        ].entries()) {
          if (self.selectedProducts[0] == cdata.name) {
            if (cdata.primary) isPrimary = true;
          }
        }
        if (isPrimary) {
          self.selectedProducts[1] = compData.comp1;
          self.selectedProducts[2] = compData.comp2;
        }
      }
      self.products = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let cci = 0;
      for (let [pi, pdata] of this.selectedProducts.entries()) {
        for (let [ci, cdata] of this.productList[this.channelSelector][
          this.selectedItemCategory.key
        ].entries()) {
          if (pdata == cdata.name) {
            let obj = {
              brand: "test",
              color: color[cci],
              forum: false,
              primary: cdata.primary,
              product_name: cdata.name,
            };
            self.products.push(obj);
            if (cci == color.length - 1) cci = 0;
            else cci++;
          }
        }
      }

      self.refresh();
    },
    getProductRecentRating() {
      let self = this;
      for (let [i, k] of this.selectedProducts.entries()) {
        this.loader = true;
        const url = "api/india_clinets/get_product_recent_rating";
        let payload = {
          channel: this.channelSelector,
          start_date: this.date.startDate,
          end_date: this.date.endDate,
          item_category: this.selectedItemCategory.key,
          client: self.client,
          product_name: k,
        };
        this.$http.post(url, payload).then(
          (response) => {
            this.recentRating[k] = response.data.data;
          },
          (err) => {
            this.loader = false;
          }
        );
      }
    },
    drawStackChart() {
      let self = this;
      let dataNeutral = [];
      let dataPositive = [];
      let dataNegative = [];
      let category = [];
      for (let [i, k] of this.data.entries()) {
        category.push(k.product_name.toUpperCase());
        dataNeutral.push(k.rating_sentiment["neutral"].count);
        dataPositive.push(k.rating_sentiment["positive"].count);
        dataNegative.push(k.rating_sentiment["negative"].count);
      }
      this.charts.stackgraph = {
        chart: {
          type: "column",
          height: 300,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: category,
        },
        yAxis: {
          min: 0,
          max: 100,
          tickInterval: 10,
          title: {
            text: "",
          },
          stackLabels: {
            enabled: false,
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = this.point.category + "<br/>";
            mytooltip +=
              '<span style="color:' + this.point.series.color + '">\u25CF</span> ';
            mytooltip += this.point.series.name;
            mytooltip +=
              " : <b> " +
              self.format(this.point.y) +
              " (" +
              self.format(this.point.percentage) +
              "%)</b> <br/>";
            mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
            return mytooltip;
          },
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          column: {
            stacking: "percent",
            borderWidth: 0,
            dataLabels: {
              enabled: false,
            },
          },
        },
        series: [
          {
            name: "Neutral",
            data: dataNeutral,
            color: "#B3B2B9",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Positive",
            data: dataPositive,
            color: "#1ACF85",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Negative",
            data: dataNegative,
            color: "#FF786B",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
    },
    drawCircularChart() {
      let self = this;
      let series = [];
      let color_codes = [
        "#47A694",
        "#54736D",
        "#265950",
        "#79A69E",
        "#317367",
        "#54736D",
        "#52BFAB",
        "#84B5AC",
        "#5F827C",
        "#388273",
        "#59CFB7",
      ];
      for (let [i, k] of this.data.entries()) {
        for (let [idx, dataset] of this.productList[this.channelSelector][
          this.selectedItemCategory.key
        ].entries()) {
          if (dataset.name == k.product_name) {
            let data = {};
            data.name = k.product_name.toUpperCase();
            data.y = k.count;
            // data.color = dataset.color
            series.push(data);
          }
        }
      }
      this.charts.circlular = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin: [0, 0, 0, 0],
          padding: [0, 0, 0, 0],
          height: 300,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="color:' + this.point.series.color + '">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip +=
              " : <b> " +
              self.format(this.point.y) +
              " (" +
              self.format(this.point.percentage) +
              "%)</b> <br/>";
            mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            borderWidth: 0,
          },
          pie: {
            dataLabels: {
              enabled: true,
              distance: -15,
              format: "{point.percentage:.1f} %",
              style: {
                fontSize: 10,
              },
            },
            showInLegend: true,
            startAngle: -180,
            endAngle: 180,
            center: ["50%", "37%"],
            size: "74%",
            colors: color_codes,
          },
        },
        legend: {
          itemStyle: {
            fontSize: 9,
          },
        },
        series: [
          {
            type: "pie",
            innerSize: "50%",
            data: series,
          },
        ],
      };
    },
    format(v) {
      return this.$options.filters.format(v);
    },

    refresh() {
      this.date = this.$refs.datecomponent.date;
      this.getProductRecentRating();
      this.getData();
      this.getChartData();
    },
    getData() {
      this.loader = true;
      const url =
        "/api/reviews/bulk?channel=" +
        this.channelSelector +
        "&start_date=" +
        this.date.startDate +
        "&end_date=" +
        this.date.endDate +
        "&interval=" +
        this.selected +
        "&products=" +
        this.selectedProducts;
      this.$http.get(url).then(
        (response) => {
          this.data = response.body.data;
          this.loader = false;
          this.createReviewCountMapper();
          this.drawCircularChart();
          this.drawStackChart();
        },
        (err) => {
          this.loader = false;
        }
      );
    },
    createReviewCountMapper() {
      this.reviewCountMapper = {};
      this.ratingMapper = {};
      for (let [idx, dataset] of this.data.entries()) {
        this.$set(this.reviewCountMapper, dataset.product_name, dataset.count);
        this.$set(this.ratingMapper, dataset.product_name, dataset);
      }
    },
    plotChart(d) {
      var self = this;
      this.charts[d.key] = {
        credits: {
          enabled: false,
        },
        chart: {},
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },

        yAxis: {
          title: {
            text: "",
          },
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            width: 70,
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y) + "</b> <br/>";
            }
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              states: {
                hover: {
                  radiusPlus: 1.5,
                  lineWidthPlus: 1,
                },
              },
            },
          },
        },
        series: d.series,
      };
    },
    processChartData(data, key) {
      let category = [];
      let series = [];
      let color_codes = ["#47A694", "#FCB116", "#1ACF50"];
      for (let [idx, dataset] of this.products.entries()) {
        for (let [i, k] of data.entries()) {
          if (dataset.product_name == k.product_name) {
            let obj = {};
            obj.name = k.product_name.toUpperCase();
            obj.data = [];
            obj.color = color_codes[i];
            for (let [j, x] of k.timeline.entries()) {
              obj.data.push(x[key]);
              if (i == 0) {
                category.push(x["date"]);
              }
            }
            series.push(obj);
            break;
          }
        }
      }
      this.plotChart({ key: key, series: series, category: category });
    },
    getChartData() {
      this.loader = true;
      this.activeChart = false;
      const url =
        "/api/reviews/histogram?channel=" +
        this.channelSelector +
        "&start_date=" +
        this.date.startDate +
        "&end_date=" +
        this.date.endDate +
        "&interval=" +
        this.selected +
        "&products=" +
        this.selectedProducts;
      this.$http.get(url).then(
        (response) => {
          let gKeys = Object.keys(response.body.data[0].timeline[0]);
          for (let [idx, key] of gKeys.entries()) {
            if (key != "date") {
              this.charts[key] = {};
              this.processChartData(response.body.data, key);
            }
          }
          this.activeChart = true;
          this.loader = false;
        },
        (err) => {
          this.loader = false;
        }
      );
    },
  },
};
</script>

<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.card_vivo {
  background-color: #0072ba !important;
  border: 1px solid #0072ba !important;
}
.card_realme {
  background-color: #f3b821 !important;
  border: 1px solid #f3b821 !important;
}
.card_redmi {
  background-color: #f56628 !important;
  border: 1px solid #f56628 !important;
}
.datebox {
  width: 12% !important;
}
.recent-rating {
  padding: 2px 7px;
  border-radius: 14px;
  font-size: 14px;
  background-color: #1d1d1d3b;
  vertical-align: baseline;
  line-height: normal;
  display: inline-block;
  color: #fff;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 1rem;
  padding-bottom: 5px;
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important ;
}
.positive-head {
  padding: 15px;
  background: var(--primary_client-20);
  color: var(--primary_brand);
  margin-top: -5px !important;
  border-radius: 0.5rem;
  font-weight: 600;
}
.separated-card:not(:last-child) {
  margin-right: 14px;
}
.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}
.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}
.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}
.card-title {
  color: var(--primary_brand);
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
  font-size: 20px !important;
}
</style>
